import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Bold, Medium, Book, Thin, Light } from "../../Typography/Span";
// TODO(paul, Q3): Dynamically generate eslint exceptions from this list.
export var chunkTransformations = {
    Bold: function(chunks) {
        return /*#__PURE__*/ _jsx(Bold, {
            children: chunks
        });
    },
    Medium: function(chunks) {
        return /*#__PURE__*/ _jsx(Medium, {
            children: chunks
        });
    },
    Book: function(chunks) {
        return /*#__PURE__*/ _jsx(Book, {
            children: chunks
        });
    },
    Thin: function(chunks) {
        return /*#__PURE__*/ _jsx(Thin, {
            children: chunks
        });
    },
    Light: function(chunks) {
        return /*#__PURE__*/ _jsx(Light, {
            children: chunks
        });
    },
    b: function(chunks) {
        return /*#__PURE__*/ _jsx("b", {
            children: chunks
        });
    },
    u: function(chunks) {
        return /*#__PURE__*/ _jsx("u", {
            children: chunks
        });
    },
    i: function(chunks) {
        return /*#__PURE__*/ _jsx("i", {
            children: chunks
        });
    },
    nbsp: "\xa0",
    strong: function(chunks) {
        return /*#__PURE__*/ _jsx("strong", {
            children: chunks
        });
    },
    lineBreak: /*#__PURE__*/ _jsx("br", {})
};
/**
 * A span which can be wrapped around text content to inform Google Translate
 * that the content within the span should not be translated. This is useful to
 * wrap around things like brand names that should be left unmodified even when
 * the user is viewing a page through Google Translate.
 * @link [Docs](https://web-docs.faire.team/component/NoTranslate)
 */ export var NoTranslate = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("span", {
        className: "notranslate",
        children: children
    });
};
